export const RNA_TYPE = 'RNA_TYPE';
export default RNA_TYPE;
